import React from "react"
import styled from "styled-components"
import { up } from "styled-breakpoints"
import colors from "@constants/colors"
import { columnsInMaxWidth } from "@constants/layout"
import { body, bodyBold, h3, h4 } from "@constants/typography"
import MaxWidthContainer from "@components/Layout/MaxWidthContainer"
import MaxWidthContent from "@components/Layout/MaxWidthContent"
import BackgroundImage, {
  Container as BackgroundImageContainer,
} from "@components/BackgroundImage"
import VerticalSpace from "@components/VerticalSpace"
import { MobileOnly, LaptopUpOnly } from "@utils/MediaQueries"
import { DatoResponsiveImage } from "@dato/types"

const Container = styled.div`
  ${up("laptop")} {
    display: flex;
  }

  ${BackgroundImageContainer} {
    ${up("laptop")} {
      align-items: flex-start;
      display: flex;
      height: calc(100vw * 0.18);
      min-height: 332px;
      max-height: 464px;
      background-position: right center;
      background-repeat: no-repeat;
      background-size: contain;
    }
  }
`

const Content = styled.div`
  ${up("laptop")} {
    width: 50%;
  }
`

const Header = styled.h2`
  ${h4};
  margin: 0;
  color: ${colors.obsidian};

  ${up("laptop")} {
    ${h3};
    color: ${colors.obsidian};
  }
`

const Subheader = styled.div`
  ${bodyBold}
`

const Body = styled.div`
  ${body}
  margin-top: 12px;

  ${up("laptop")} {
    margin-top: 24px;
  }
`

export interface BannerProps {
  header: string
  subheader?: string
  body?: string
  backgroundImage: DatoResponsiveImage
}

const Banner: React.FC<BannerProps> = ({
  header,
  subheader,
  body,
  backgroundImage,
}) => {
  return (
    <Container>
      <MaxWidthContainer>
        <MaxWidthContent cols={12}>
          <LaptopUpOnly>
            <BackgroundImage
              image={{ ...backgroundImage, bgColor: "transparent" }}
            >
              <Content>
                {subheader && <Subheader>{subheader}</Subheader>}
                <Header>{header}</Header>
                {body && (
                  <>
                    <VerticalSpace height={16} />
                    <Body>{body}</Body>
                  </>
                )}
              </Content>
            </BackgroundImage>
          </LaptopUpOnly>
          <MobileOnly>
            <Content>
              {subheader && <Subheader>{subheader}</Subheader>}
              <Header>{header}</Header>
              {body && <Body>{body}</Body>}
            </Content>
          </MobileOnly>
        </MaxWidthContent>
      </MaxWidthContainer>
    </Container>
  )
}

export default Banner
